// src/app/services/subscription.service.ts
import { Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { Firestore, collection, collectionData, query, where, limit, collectionGroup } from '@angular/fire/firestore';
import { from, map, Observable } from 'rxjs';
@Injectable({ providedIn: 'root' })
export class SubscriptionService {
  constructor(private functions: Functions,private firestore: Firestore) {}

  /**
   * Creates a Stripe Checkout session to start a subscription for the given user.
   * amountCents = monthly amount in cents
   */
  async createSubscriptionSession(
    uid: string,
    amountCents: number,
    rentalAddress: string,
    paymentMethod: string,
    successUrl: string,
    cancelUrl: string,
  ): Promise<string> {
    const createCall = httpsCallable(this.functions, 'createSubscriptionSession');
    const res = await createCall({
      uid,
      amount: amountCents,
      rentalAddress,
      paymentMethod,
      successUrl,
      cancelUrl,
    });
    return (res as any).data?.url;
  }
   getSubscriptionsByLandlordIds(
      landlordIds: string[]
    ): Observable<any[]> {


      const ref = collectionGroup(this.firestore, 'subscriptions');

      return collectionData(ref, { idField: 'id' }).pipe(
        map((subs: any[]) =>
          subs.filter(s => landlordIds.includes(s.landlordId))
        )
      );
    }
   getSubscriptionByTenant(uid: string): Observable<any | null> {
    const ref = collection(this.firestore, `users/${uid}/subscriptions`);
    const q = query(ref, where('status', 'in', ['active', 'trialing', 'past_due']),limit(1));
    return collectionData(q, { idField: 'id' }) as Observable<any[]>;
  }
  cancelSubscription(subscriptionId: string){
    const fn = httpsCallable(this.functions, 'cancelSubscription');
    return from(fn({ subscriptionId })); // ⬅ Convert Promise → Observable
  }
  openBillingPortal(customerId: string) {

    const fn = httpsCallable(this.functions, 'createBillingPortalSession');
    return from(fn({ customerId })); // ⬅ Convert Promise → Observable
  }
}
